import {ModuleSettings} from "../../models/modules";

export interface BlogModuleSettings extends ModuleSettings {
}

export const defaultBlogModuleSettings: BlogModuleSettings = {
  enabled: false,
}
